import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Accordion, Checkbox, CheckboxProps, Tooltip } from '@ets/design-system';

import styles from './Section.module.scss';

type TableHeaderProps = Pick<Editor.Edition.TableProperties, 'headerRow' | 'fromStart'> &
  SectionProps;

const TableHeader = ({ headerRow, fromStart, updateData }: TableHeaderProps) => {
  const intl = useIntl();

  const getCheckState = (): CheckboxProps['checked'] => {
    if (headerRow?.incoherent) {
      return 'indeterminate';
    }

    return !!headerRow?.value;
  };

  const [checkState, setCheckState] = useState(getCheckState());

  const handleHeaderRowChange = () => {
    setCheckState((prevState) => {
      switch (prevState) {
        case false:
        case 'indeterminate':
          updateData({ property: 'headerRow', value: { value: true } });
          return true;
        case true:
          updateData({ property: 'headerRow', value: { value: false } });
          return false;
      }
    });
  };

  return (
    <Accordion
      size="m"
      variant="standard"
      title={intl.formatMessage({ id: 'TABLE_HEADER' })}
      defaultOpen={true}
      testId="tableProperties-table-header"
    >
      <Tooltip
        content={intl.formatMessage({ id: 'SET_ROW_AS_TABLE_HEADER_DISABLED_WARNING' })}
        visible={!fromStart}
        testId="set-row-as-table-header"
      >
        <div className={`${styles.root} ${styles.fitContent}`} style={{ marginTop: '1rem' }}>
          <Checkbox
            size="xs"
            checked={checkState}
            onChange={handleHeaderRowChange}
            disabled={!fromStart}
            testId="set-row-as-table-header"
          />
          <FormattedMessage id="SET_ROW_AS_TABLE_HEADER" />
        </div>
      </Tooltip>
    </Accordion>
  );
};

export default TableHeader;
